import React from 'react';
import { Input, message } from 'antd';
import styles from './Index.less';

export default class EditableCell extends React.Component {
  state = {
    value: this.props.value,
  };

  componentWillReceiveProps(nextProps) {
    this.setState({ value: nextProps.value });
  }

  handleChange = e => {
    const { value } = e.target;
    this.setState({ value });
  };

  check = () => {
    const { lowPrice, highPrice } = this.props;

    const { value } = this.state;

    if (Number.isNaN(value)) {
      return message.warning('请输入合法的金额');
    }

    if (value <= lowPrice || value > highPrice) {
      return message.warning(`价格区应大于${lowPrice}并且小于等于${highPrice}`);
    }

    if (this.props.onChange) {
      this.props.onChange(value);
    }
  };

  render() {
    const { value } = this.state;

    return (
      <div className={styles['editable-cell']}>
        <Input value={value} onChange={this.handleChange} onBlur={this.check} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components_business/SkusEdit/SkusTable/EditableCell/Index.js